export let dataProps = {
    id: 0,
    voucher_number: null,
    external_number: '',
    store_id: null, 
    customer_id: null,
    sale_person_staff_id: null,
    message: '',
    sale_date: new Date(),
    expiry_date: new Date(),
    amount: 0,
    payment_mode_id: null,
    redeem_customer_payment_id: 0
}


// WEBPACK FOOTER //
// ./src/store/modules/giftCard/properties.js